import React, { FunctionComponent, useMemo, useState } from "react";
import { GroupWorkSpace } from "../WorkspacesContainer";
import WorkspaceHeader from "../WorkspaceHeader";
import LessonNotesContainer from "./LessonNotesContainer";
import { faPlusCircle, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InterventionGroup, LessonNotes } from "../../../../../../../../../store/onboarding/cases/types";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../../../../../../../store";
import useInterventionGroupAccess from "../../../../../../../../../utils/hooks/useInterventionGroupAccess";
import { Form, InputGroup } from "react-bootstrap";

type Props = {
  interventionGroup: InterventionGroup;
  expanded?: boolean;
  workspace: GroupWorkSpace;
  setExpandedWorkSpace: React.Dispatch<
    React.SetStateAction<GroupWorkSpace | undefined>
  >;
};

const LessonNotesWorkspace: FunctionComponent<Props> = (props) => {
  const { expanded, workspace, setExpandedWorkSpace, interventionGroup } = props;

  const [showUpsertForm, setShowUpsertForm] = useState<boolean>(false);
  const [selectedLessonNotes, setSelectedLessonNotes] = useState<
    LessonNotes | undefined
  >();
  const [lessonNoteSearchStr, setLessonNoteSearchStr] = useState("");

  const { isIntGrpIDsWithReadAccess } = useInterventionGroupAccess(interventionGroup.id);

  const isStudentDetail =  useSelector(
    (s: ApplicationState) => s.cases.isStudentDetail
  );

  const isGroupDetail =  useSelector(
    (s: ApplicationState) => s.cases.isGroupDetail
  );

  const onLessonNoteFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setLessonNoteSearchStr(value);
  };

  return (
    <div>
      <WorkspaceHeader
        expanded={expanded}
        workspace={workspace}
        setExpandedWorkSpace={setExpandedWorkSpace}
        header={
          <div className={`workspace-header-container w-100 ${expanded ? 'workspace-expanded' : 'workspace-collapsed'}`}>
            <div className="d-flex align-items-center flex-shrink-0 workspace-title-row">
              <span className="workspace-title">My Notes & Collaboration</span>
              {!isStudentDetail && !isGroupDetail && !isIntGrpIDsWithReadAccess && !showUpsertForm && (
                <span
                  className="ml-2 pointer"
                  onClick={() => {
                    setSelectedLessonNotes(undefined);
                    setShowUpsertForm(true);
                  }}
                >
                  <FontAwesomeIcon title="Add New Notes" icon={faPlusCircle} />
                </span>
              )}
            </div>
            {!showUpsertForm && (
              <div className="workspace-search-container">
                <InputGroup className="searchBox">
                  <InputGroup.Prepend>
                    <InputGroup.Text className="searchIcon">
                      <FontAwesomeIcon icon={faSearch} style={{ color: "#90a4ae" }} />
                    </InputGroup.Text>
                  </InputGroup.Prepend>

                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={lessonNoteSearchStr || ""}
                    onChange={onLessonNoteFilterChange}
                    className="searchInput"
                  />
                </InputGroup>
              </div>
            )}
          </div>
        }
      />
      <div className="workspace-body">
        <LessonNotesContainer
          showUpsertForm={showUpsertForm}
          setShowUpsertForm={setShowUpsertForm}
          selectedLessonNotes={selectedLessonNotes}
          setSelectedLessonNotes={setSelectedLessonNotes}
          isStudentDetail={isStudentDetail}
          isGroupDetail={isGroupDetail}
          lessonNoteSearchStr={lessonNoteSearchStr}
        />
      </div>
    </div>
  );
};

export default LessonNotesWorkspace;
